<template>
	<k-editor-form v-if="channel">
		<template v-slot:left>
			<div v-for="info in get_status" class="elevation-1">
				<div style="display: grid; grid-template-columns: max-content 1fr max-content; grid-gap: 4px;">
	      	<k-icon :color="get_icon_color(info)" small>circle</k-icon>
	    		<channel-title :channel="channel" :alternative="info.alternative"></channel-title>
	    		<template v-if="$is_admin() && headend(info)">
	    			<k-chip size="xs">{{headend(info).title}}</k-chip>
	    		</template>
	    	</div>

	    	<template v-if="source_state(info)">
<!-- FIXME: Source connected ikoniksi ja teksti pois -->
    			<template v-if="source_type(info) == 'server'">
<!--    				{{info}}
    				Server-->
    			</template>
    			<template v-if="source_type(info) == 'client'">
    			</template>
    			<template v-if="source_type(info) == 'srt_client'">
    				<div>
	    				SRT Stats:
				  		<srt-stats :stats="srt_stats(info)"></srt-stats>
				  	</div>
    			</template>
	    	</template>

	    	<!-- FIXME: Mistä saadaan tieto millä srt serverillä joku on jotta saatais kunnon tilastot? -->
<!-- Jos ei ole instanssia niin saatasko katsottua srt servereiden statsit läpi, tosin ne ei taida tulla kokonaan jatkuvasti...-->

<!--	    	<template v-if="$is_admin() && output_state(info)">
	    		<div>
	    			Output:
		    		{{output_state(info)}}
		    	</div>
	    	</template>-->

	    	<template v-if="source_state(info) == 'connected'">
	  			<analyzer :channel="channel.uuid" :alternative="info.alternative"></analyzer>
	  		</template>

<!--    		{{info.status}}-->
				
    	</div>


		</template>
		<template #right>
			<template v-if="instance_id && $is_admin()">
				<instance-stats :id="instance_id"></instance-stats>
			</template>
		</template>
		<template v-slot:right-buttons>
						<k-btn size="m" color="primary" @click="close">Close</k-btn>
		</template>
	</k-editor-form>

</template>

<script>

import ChannelModel from '@/models/channel.js';
import InstanceModel from '@/models/instance.js';
import ChannelTitle from '@/components/ChannelTitle.vue';
import SrtStats from '@/components/stats/Srt.vue';
import InstanceStats from '@/components/instances/Stats.vue';
import Analyzer from '../Analyzer.vue';

export default {
	props: ["id"],
	components: {
		ChannelTitle,
		SrtStats,
		InstanceStats,
		Analyzer
	},
	data () {
		return {}
	},
	methods: {
    get_icon_color(info) {
    	var state = this.source_state(info);

			if (state == "connected") return "success";
			if (state == "connecting") return "warning";
			if (state == "listening") return "warning"
			if (state == "disconnected") return "warning";
			return "primary";
		},
		source_state(info) {
			return _.get(info, ["status","instance", "source", "state"], "");
		},
		source_type(info) {
			return _.get(info, ["status","instance", "source", "info", "type"], "");
		},
		output_state(info) {
			return _.get(info, ["status", "instance", "output"]);
		},
		srt_stats(info) {
			return _.get(info, ["status", "instance", "source", "info", "srt_stats"]);
		},
		headend(info) {
			return ChannelModel.headend(this.channel, info.alternative);
		},
		close () {
			this.$root.close_bottom_sheet();

		},
		start_channel (alternative) {
      ChannelModel.port_request(this.channel, alternative, function(msg) {
      }, function(msg) {
      	
      });
    },
    stop_channel (alternative) {
      ChannelModel.stop_channel(this.channel, alternative, function(msg) {
      }, function(msg) {
      });
    },

	},
	computed: {
		instance_id () {
			var instance = ChannelModel.instance(this.channel);
			if (typeof(instance) == "undefined") return null;
			return instance.id;
		},
		all_status() {
			return ChannelModel.status_all();
		},
		get_status() {
			var self = this;
			var ret = [
				{"alternative": "", "status": ChannelModel.status(this.id)}
			]
			var alternatives = ChannelModel.get_alternatives(this.id);
			_.each(alternatives, function(alternative) {
					ret.push({
						"alternative": alternative.alternative,
						"status": ChannelModel.status(self.id, alternative.alternative)
					});
			});
			return ret;
		},
		channel() {
			return ChannelModel.get_channel(this.id);
		}
	}
}
</script>